// extracted by mini-css-extract-plugin
export default {"main":"_1Xnsz"};